import { IconProps } from "./IconProps";

const WarningIcon = ({ size = 24, color, testID }: IconProps) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.824 16.8112L11.0494 2.25932C10.8276 1.89155 10.4295 1.66667 9.99996 1.66667C9.57047 1.66667 9.1723 1.89151 8.95055 2.25932L0.176014 16.8112C-0.0521894 17.1897 -0.0589473 17.6618 0.158397 18.0466C0.37574 18.4314 0.783436 18.6694 1.22539 18.6694H18.7746C19.2165 18.6694 19.6242 18.4314 19.8416 18.0466C20.0589 17.6617 20.0522 17.1897 19.824 16.8112ZM10.0065 6.70034C10.5105 6.70034 10.9369 6.98464 10.9369 7.48854C10.9369 9.02616 10.756 11.2358 10.756 12.7734C10.756 13.174 10.3166 13.3419 10.0065 13.3419C9.59308 13.3419 9.24418 13.1739 9.24418 12.7734C9.24418 11.2358 9.06332 9.02616 9.06332 7.48854C9.06332 6.98464 9.47676 6.70034 10.0065 6.70034ZM10.0195 16.2234C9.45094 16.2234 9.02449 15.7583 9.02449 15.2285C9.02449 14.6858 9.4509 14.2336 10.0195 14.2336C10.5492 14.2336 11.0015 14.6858 11.0015 15.2285C11.0015 15.7583 10.5492 16.2234 10.0195 16.2234Z"
      fill="#A05F03"
    />
  </svg>
);

export { WarningIcon };
